import React, {useEffect} from 'react';
import renderHTML from 'react-render-html';
import './Alert.sass';
import gsap from 'gsap';
import VideoPlayer from '../../../VideoPlayer';

const Alert = ({data, continueTo}) => {
    const {body, customerVideo, image, linkage, title} = data;

    useEffect(() => {
        const tl = gsap.timeline();
        tl.from('.alert--video', 0.3, {x: -1600});
        tl.from('.alert--content', 0.3, {x: 1600, delay: 0.2});
    }, []);

    const handleClick = (linkage) => {
        const tl = gsap.timeline();
        tl.to('.alert--video', 0.3, {x: -1600});
        tl.to('.alert--content', 0.3, {x: 1600});

        setTimeout(function () {
            continueTo(linkage);
        }, 500);
    };

    return (
        <div className="Alert">
            <div className="alert--display">
                {customerVideo ? (
                    <VideoPlayer
                        src={customerVideo}
                        autoplay={true}
                    />
                ) : (
                    (image) ?
                        (<img src={image}/>) : null

                )}
            </div>
            <div className="alert--content">
                <div className={"alert-title"}>{title}</div>
                {renderHTML(body)}

            </div>
            <button onClick={() => handleClick(linkage)}
                    className="continue">
                CONTINUE
            </button>
        </div>
    );
};

export default Alert;
